import React, { useRef } from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';
import LinkJump from '@gp/components/LinkJump';
import { Menu } from 'tea-component';
import { IMenuItemType } from '@/pages/home/components/LeftMenu/type';
import NewMarkIcon from '@home/components/NewMarkIcon';

interface IMenuItemPropsType {
  menu: IMenuItemType;
  menuPa: IMenuItemType;
  selected: boolean;
  onClick: (menu: IMenuItemType, menuPa: IMenuItemType) => void;
  className?: string;
  isHyperlink: boolean;
  setBubbleInfo: any;
}

const MenuItemComp = (props: IMenuItemPropsType) => {
  const {
    menu,
    selected,
    onClick,
    className,
    menuPa,
    isHyperlink,
    setBubbleInfo,
  } = props;

  const menuRef = useRef<HTMLLIElement>(null);
  const handleMouseEnter = () => {
    const menuTitle = menuRef.current?.getElementsByClassName(`js-menu-context-text-${menu?.id}`)[0];
    if (menuTitle && menuTitle?.scrollHeight > menuTitle?.clientHeight) {
      setBubbleInfo({
        menu,
        ele: menuRef.current
      });
    }
  };

  const handleMouseLeave = () => {
    setBubbleInfo(null);
  };

  return (
    <LinkJump url={isHyperlink ? menu.path : ''}>
      <Menu.Item
        ref={menuRef}
        // @ts-ignore
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        selected={selected}
        onClick={() => { onClick(menu, menuPa) }}
        className={`js-menu-common-${menu.id} ${className || ''}`}
        key={menu.id}
        // showNew逻辑开发需调整，此处仅模拟展示，注意类名差异
        title={
          <div className="left-nav-text-hd">
            <span className={`menu-context-text js-menu-context-text-${menu?.id}`}>{menu.text}</span>
            {menu?.showNew && <NewMarkIcon className={`left-nav-notice ${menu?.newMarkType === 1 ? 'dbh-beta-tag' : ''}`} type={menu?.newMarkType} />}
          </div>
        }
        icon={
          <SvgIcon className="left-nav-icon" type={menu.icon || 'default'} />
        }
      />
    </LinkJump >
  );
};

export default MenuItemComp;

